export default __webpack_public_path__ + "static/B0031-09300c4d70bf8708a3ee565a537477b3.png";